import React from "react";
import "../styles/About.css";

import deliveryMan from "../../assets/delivery-man.png";
import scanBox from "../../assets/scan-box.png";
import trucks from "../../assets/trucks.png";

const AboutUs = () => {
  return (
    <div className="about-page">

      {/* HERO SECTION */}
      <section className="about-hero">
        <div className="hero-overlay">
          <h1>About SCPL</h1>
          <p>
            Connecting businesses and individuals across India with fast,
            reliable, and affordable logistics solutions.
          </p>
        </div>
      </section>

      {/* ABOUT CONTENT */}
      <section className="about-content container">
        <div className="about-text">
          <h2>About Us</h2>

          <p>
            <strong>SPARSH CARGO PRIVATE LIMITED</strong> is a professionally
            managed logistics company incorporated on 28th May 2009 and
            registered with the Registrar of Companies (ROC), Delhi.
          </p>

          <p>
            With over 15 years of industry presence, the company has built a
            strong foundation in logistics and supply chain management.
          </p>

          <p>
            The company is led by experienced directors Ms. Urmila Rawat and
            Mr. Kuldeep Rawat Singh, whose leadership has driven operational
            excellence and steady growth.
          </p>

          <p>
            SCPL delivers reliable logistics solutions across e-commerce,
            retail, and distribution sectors with a strong customer-centric
            approach.
          </p>
        </div>

        <div className="about-image">
          <img src={deliveryMan} alt="Delivery Executive" />
        </div>
      </section>

      {/* STATS */}
      <section className="about-stats">
        <div>
          <h3>15k+</h3>
          <p>Clients Served</p>
        </div>
        <div>
          <h3>5+</h3>
          <p>Branches</p>
        </div>
      </section>

      {/* FEATURES */}
      <section className="features container">
        <h2>Benefits of Our Logistics Services</h2>

        <div className="feature-grid">
          <div className="feature-card">Affordable Cost</div>
          <div className="feature-card">Fast Delivery</div>
          <div className="feature-card">Live Tracking</div>
          <div className="feature-card">24/7 Support</div>
        </div>
      </section>

      {/* MISSION */}
      <section className="mission container">
        <div className="mission-image">
          <img src={scanBox} alt="Package Scanning" />
        </div>

        <div className="mission-text">
          <h2>Our Mission</h2>
          <p>
            To connect businesses and individuals through reliable,
            technology-driven logistics solutions.
          </p>
          <p>
            We focus on speed, transparency, and customer satisfaction.
          </p>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="why-us">
        <div className="overlay">
          <h2>Why Choose SCPL?</h2>
          <ul>
            <li>Strong Logistics Network</li>
            <li>Affordable Pricing</li>
            <li>Timely Deliveries</li>
            <li>Customized Solutions</li>
            <li>Advanced Tracking System</li>
          </ul>
        </div>
      </section>

      {/* TRUCK IMAGE */}
      <section className="truck-section">
        <img src={trucks} alt="Logistics Trucks" />
      </section>

    </div>
  );
};

export default AboutUs;
